import { Component, input, Input, OnInit, viewChild, ViewChild } from '@angular/core';

import { ModalComponent, SpinnerComponent, TooltipComponent } from 'remarketing-ui-components-lib';
import {
  OfferModalsHeaderComponent
} from '../../../../shared/ui/comment/modal-actions/offer-header/offer-modals-header.component';
import { PurchaseStatusPipe } from 'smartauction-frontend-micro-library';
import { TranslocoDirective } from '@jsverse/transloco';
import { PurchaseHistoryComponent } from '../../purchase-history/purchase-history.component';
import { AuctionItemSell, InventoryManagementSearchResult } from 'remarketing-angular-library';
import { PurchaseHistory } from '@ally/remarketing/shared/dto';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-purchase-offer-history-modal',
  imports: [
    ModalComponent,
    OfferModalsHeaderComponent,
    PurchaseStatusPipe,
    SpinnerComponent,
    TooltipComponent,
    TranslocoDirective,
    CommonModule
  ],
  templateUrl: './purchase-offer-history-modal.component.html',
  styleUrl: './purchase-offer-history-modal.component.scss'
})
export class PurchaseOfferHistoryModalComponent extends PurchaseHistoryComponent implements OnInit {
  readonly modal$ = viewChild.required<ModalComponent>(ModalComponent);

  readonly auctionItemSell$ = input.required<VehicleHistoryItem>();
  readonly modalId$ = input<string>('purchase-offer-history-modal');
  readonly tenantName$ = input<string>();
  readonly saleDate$ = input<string>();
  readonly salePrice$ = input<number>();
  readonly vehicleTitle$ = input<string>();

  public isLoading = true;

  purchaseOfferHistory: PurchaseHistory;
  historyCount = 0;
  isMobile: boolean;

  ngOnInit() {
    // overrides ngOnInit from extended class - this is how it was in sell module
  }

  show() {
    this.isLoading = true;

    const inputVehicleHistoryItem = this.auctionItemSell$();
    const vehicleIdentifier = (inputVehicleHistoryItem && 'vehicleUuid' in inputVehicleHistoryItem)
      ? inputVehicleHistoryItem.vehicleUuid
      : (inputVehicleHistoryItem && 'auctionItemUuid' in inputVehicleHistoryItem)
        ? inputVehicleHistoryItem.auctionItemUuid
        : undefined;

    this.getAuctionItemSellHistory(vehicleIdentifier);
    this.isLoading = false;
    this.modal$().show();
  }
}

export type VehicleHistoryItem = AuctionItemSell | InventoryManagementSearchResult;
